import Token from '../../data/models/Token'


export const register = (data) => ({
  token: Token(data?.register),
  user: data?.register?.user,
})

